<script>
import LoadingSpinner from '../../../components/LoadingSpinner';
import { Line, mixins } from 'vue-chartjs';
import { mapGetters, mapActions } from 'vuex';

export default {
  extends: Line,
  mixins: [mixins.reactiveProp],
  components: {},
  mounted() {},
  props: ['chartData', 'height'],
  data() {
    return {
      isLoading: false
    };
  },
  computed: {},
  created() {},
  mounted() {
    this.render();
  },
  methods: {
    render() {
      this.renderChart(this.chartData, {
        title: {
          display: true,
          text: 'Postage (cumulative)',
        },
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        scales: {
          xAxes: [
            {
              display: true
            }
          ],
          yAxes: [
            {
              display: true,
              ticks: {
                suggestedMin: 0,
                stepSize: 10
              }
            }
          ]
        },
        elements: {
          point: {
            radius: 0,
            hitRadius: 10,
            hoverRadius: 4,
            hoverBorderWidth: 3
          }
        }
      });
    }
  }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/views/Admin/charts/UserPostageChart.vue